import DeviceIndex from '@/views/device/index';
import CommonMain from '@/views/commonMain';

export default {
  path: '/device',
  component: CommonMain,
  redirect: '/device',
  children: [
    {
      name: 'device',
      meta: { title: '设备管理' },
      path: '',
      component: DeviceIndex,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/device.js